export default "__VITE_ASSET__CC$udchJ__"